

module.exports = __webpack_require__.stylable.create(
    "Pagination3102036801",
    {"classes":{"root":"Pagination3102036801__root","dot":"Pagination3102036801__dot"},"vars":{},"stVars":{},"keyframes":{}},
    ".Pagination3102036801__root{display:flex;justify-content:center}.Pagination3102036801__root.slick-dots{position:static;margin-top:24px}.Pagination3102036801__root.slick-dots li.slick-active{background-color:var(--wsr-color-00, #2B81CB)}.Pagination3102036801__root .Pagination3102036801__dot{width:12px;height:4px;background-color:var(--wsr-color-30, #C1E4FE);border-radius:2px;margin:0 3px}.Pagination3102036801__root .Pagination3102036801__dot:hover{background-color:var(--wsr-color-20, #4EB7F5)}",
    2,
    "Pagination3102036801",
    __webpack_require__.stylable.$
);
